module.exports = __webpack_public_path__ + "static/media/tt.3854b853.svg";